import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminQuickActions from '../components/AdminQuickActions';
import SEO from '../components/SEO';
import { db } from '../firebase';
import '../styles/AdminQuickActions.css';
import '../styles/Blog.css';

// No default articles - only display what's in Firestore

const Blog = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Clear any localStorage cache to ensure clean state
    localStorage.removeItem('blogArticles');
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Fetch from Firestore only
      const articlesRef = collection(db, 'articles');
      const q = query(articlesRef, orderBy('date', 'desc'));
      const querySnapshot = await getDocs(q);
      
      const articles = querySnapshot.docs.map(doc => ({
        id: String(doc.id), // Ensure ID is string
        ...doc.data()
      }));
      
      console.log('Firestore articles:', articles.length);
      setBlogPosts(articles);
    } catch (error) {
      console.error('Error fetching articles:', error);
      setError('Failed to load articles from cloud storage');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="blog-page">
        <SEO 
          title="Car Maintenance Blog - Expert Tips & Guides | LogiCar"
          description="Discover expert car maintenance tips, guides, and advice from LogiCar. Learn how to keep your vehicle in perfect condition with our comprehensive blog."
          keywords="car maintenance blog, automotive tips, vehicle care guide, car service advice, maintenance tips"
          canonical="https://www.logicarapp.com/blog"
        />
        <div className="container">
          <div className="loading">
            <h1>Loading articles...</h1>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="blog-page">
        <SEO 
          title="Car Maintenance Blog - Expert Tips & Guides | LogiCar"
          description="Discover expert car maintenance tips, guides, and advice from LogiCar. Learn how to keep your vehicle in perfect condition with our comprehensive blog."
          keywords="car maintenance blog, automotive tips, vehicle care guide, car service advice, maintenance tips"
          canonical="https://www.logicarapp.com/blog"
        />
        <div className="container">
          <div className="error">
            <h1>Error loading articles</h1>
            <p>{error}</p>
            <button onClick={fetchArticles} className="retry-btn">Try Again</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-page">
      <SEO 
        title="Car Maintenance Blog - Expert Tips & Guides | LogiCar"
        description="Discover expert car maintenance tips, guides, and advice from LogiCar. Learn how to keep your vehicle in perfect condition with our comprehensive blog."
        keywords="car maintenance blog, automotive tips, vehicle care guide, car service advice, maintenance tips"
        canonical="https://www.logicarapp.com/blog"
      />
      
      <div className="container">
        <div className="blog-header">
          <h1>Car Maintenance Blog</h1>
          <p>Expert tips and guides to help you maintain your vehicle like a pro</p>
        </div>


        {/* Blog Posts Grid */}
        {blogPosts.length > 0 ? (
          <section className="blog-posts">
            <div className="posts-grid">
              {blogPosts.map(post => (
                <article key={post.id} className="blog-post-card">
                  {post.image && (
                    <div className="post-image">
                      <img src={post.image} alt={post.title} />
                    </div>
                  )}
                  <div className="post-content">
                    {post.category && (
                      <div className="post-meta">
                        <span className="category">{post.category}</span>
                        {post.readTime && (
                          <span className="read-time">{post.readTime}</span>
                        )}
                      </div>
                    )}
                    <h3>
                      <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                    </h3>
                    <p>{post.excerpt}</p>
                    <div className="post-footer">
                      {post.date && (
                        <span className="post-date">{new Date(post.date).toLocaleDateString('en-US', { 
                          year: 'numeric', 
                          month: 'long', 
                          day: 'numeric' 
                        })}</span>
                      )}
                      <Link to={`/blog/${post.slug}`} className="read-more">
                        Read More <i className="fas fa-arrow-right"></i>
                      </Link>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </section>
        ) : (
          <div className="no-posts">
            <div className="no-posts-content">
              <i className="fas fa-newspaper"></i>
              <h3>No articles yet</h3>
              <p>Check back soon for expert car maintenance tips and guides!</p>
            </div>
          </div>
        )}

      </div>
      
      {/* Admin Quick Actions */}
      <AdminQuickActions />
    </div>
  );
};

export default Blog;
